module.exports = __webpack_public_path__ + "img/ticket.13673af4.svg";